import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { get_Date, commaSeprateString } from "../../Utils/commonFunctions";
import { getSurveyAnalysisDownload } from "../../Utils/adminFunctions";
import {
  PDFDownloadLink,
  Page,
  Text,
  Image,
  Document,
  Svg,
} from "@react-pdf/renderer";

import { AdminQuestionOptionDownload } from "./AdminCommanComponent";

const AdminAnalysisDownload = () => {
  const { surveyID, questionID, questionNo } = useParams();
  const [questionData, setQuestionData] = useState("");
  const [chartQuestion, setChartQuestion] = useState("");
  const [questionType, setQuestionType] = useState("");
  const [isChart, setIsChart] = useState(0);
  const [colors, setColors] = useState([]);
  const [reportsChartsData, setReportsChartsData] = useState("");
  const [options, setOptions] = useState("");
  useEffect(() => {
    UserSurveyAnalysisPreviewDownlad();
  }, []);
  const UserSurveyAnalysisPreviewDownlad = async () => {
    const bodyFormData = new FormData();
    bodyFormData.append("survey_id", surveyID);
    bodyFormData.append("question_id", questionID);
    bodyFormData.append("question_no", questionNo);
    const response = await getSurveyAnalysisDownload(bodyFormData);
    if (response.status === "success") {
      setQuestionData(response.data[0]);
      setColors(response.data[0].COLOR);
      if (Object.keys(response.data[0].reportscharts).length === 0) {
        setIsChart(0);
        setReportsChartsData("");
      } else {
        setIsChart(1);
        let breakPoint = "";
        let tempChartData = response.data[0].reportscharts.map(
          (item, index) => {
            if (index != 0) {
              breakPoint = "break";
            }
            return (
              <>
                <div
                  style={{
                    border: 1,
                    borderRadius: 5,
                    borderColor: "#dee2e6",
                    marginTop: "3%",
                    marginLeft: "1.2%",
                  }}
                  break={breakPoint}
                >
                  <Image src={item.analysis_graph_img} />

                  <div style={{ marginLeft: 20 }}>
                    <Text style={{ fontSize: 10, margin: 4 }}>Region:</Text>

                    <Text style={{ fontSize: 10, margin: 4 }}>
                      {commaSeprateString(item.graph_region)}
                    </Text>

                    <Text style={{ fontSize: 10, margin: 4 }}>Country: </Text>

                    <Text style={{ fontSize: 10, margin: 4 }}>
                      {commaSeprateString(item.graph_country)}
                    </Text>

                    <Text style={{ fontSize: 10, margin: 4 }}>
                      Profession:{" "}
                    </Text>

                    <Text style={{ fontSize: 10, margin: 4 }}>
                      {commaSeprateString(item.graph_profession)}
                    </Text>
                  </div>
                </div>
              </>
            );
          }
        );
        setReportsChartsData(tempChartData);
      }
      if (response.data[0].chartquestion.options === "") {
        setOptions("");
      } else {
        setOptions(response.data[0].chartquestion.options);
      }
      setChartQuestion(response.data[0].chartquestion);
      setQuestionType(response.data[0].chartquestion.type);
    }
  };

  const MyDocument = () => (
    <Document>
      <Page size="A4" style={{ padding: "30px" }}>
        <Image
          style={{ maxHeight: 35, marginLeft: "1.2%", maxWidth: 75 }}
          src={questionData.manufacturer__company_logo}
          fixed
        />

        <div
          style={{
            flexDirection: "row",
            marginTop: "3%",
            width: "100%",
          }}
        >
          <div style={{ width: "25%" }}>
            <Text style={{ fontSize: 11, margin: 6 }}>
              No. of responses/Total Participants
            </Text>

            <Text style={{ fontSize: 11, margin: 6 }}>Lunch Date</Text>

            <Text style={{ fontSize: 11, margin: 6 }}>Completion Date</Text>
          </div>

          <div style={{ width: "25%" }}>
            <Text style={{ fontSize: 11, margin: 6 }}>
              {questionData.no_of_paticipants}/{questionData.no_of_responses}
            </Text>

            <Text style={{ fontSize: 11, margin: 6, marginTop: 20 }}>
              {get_Date(questionData.launch_date)}
            </Text>

            <Text style={{ fontSize: 11, margin: 6 }}>
              {get_Date(questionData.completion_date)}
            </Text>
          </div>

          <div style={{ Width: "50%" }}>
            <Image
              style={{
                maxHeight: "85px",
                maxWidth: "40%",
                alignSelf: "center",
                marginLeft: "20%",
              }}
              src={questionData.device__device_image}
              alt="N/A"
            />

            <Text
              style={{
                fontSize: 11,
                alignSelf: "center",
                marginLeft: "20%",
                marginTop: "10px",
              }}
            >
              {questionData.device__device_name}
            </Text>
          </div>
        </div>
        <div
          style={{
            border: 1,
            padding: 6,
            borderRadius: 5,
            marginTop: "3%",
            borderColor: "#006cb5",
            marginLeft: "1.2%",
          }}
        >
          <Text style={{ fontSize: 11 }}>
            <Text
              style={{
                backgroundColor: "#006cb5",
                width: "30px",
                color: "#ffffff",
                borderRadius: "5px",
                marginRight: "1rem",
              }}
            >
              {questionNo}
            </Text>
            . {chartQuestion.label}
          </Text>
        </div>

        {(chartQuestion.type === "radio" ||
          chartQuestion.type === "selectboxes" ||
          chartQuestion.type === "survey") && (
          <Svg>
            <AdminQuestionOptionDownload
              questionType={questionType}
              isChart={isChart}
              options={options}
              colors={colors}
            />
          </Svg>
        )}
        {reportsChartsData != "" && reportsChartsData}
      </Page>
    </Document>
  );

  return (
    <div>
      <PDFDownloadLink
        document={<MyDocument />}
        fileName={surveyID + questionID + "_Report" + ".pdf"}
      >
        {({ blob, url, loading, error }) =>
          loading ? (
            "Loading document..."
          ) : (
            <button className="btn btn-sm btn-success custom-btn-primary">
              <i className="fa fa-download"></i> Download
            </button>
          )
        }
      </PDFDownloadLink>
    </div>
  );
};

export default AdminAnalysisDownload;
